import { INSPECTION_WRITEOUTS } from "../constants";
import { getApiUrl } from "../utils/get-api-url";
import { policyIdRequiredError } from "../components/policy-view/utils/constants";

/**
 * getPolicyEnrollmentStatus()
 * @param {policyId} param0 string
 *
 * Takes the policy ID and returns an object of enrollment statuses:
 * - MySageSure account
 * - Paperless (documents & billing)
 * - Billing (payment method type)
 */
export const getPolicyEnrollmentStatuses = async ({ policyId }) => {
  if (!policyId) return Promise.reject(policyIdRequiredError);
  const apiUrl = getApiUrl("quotesapi");
  const fullUrl = `${apiUrl}/enrollment-status/${policyId}`;
  const response = await fetch(fullUrl, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include"
  });
  const { headers: resHeaders, statusText, ok } = response;
  const contentType = resHeaders.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    throw new Error(
      statusText ||
        "Network request failed to get Policy Enrollment Statuses from Quotes API."
    );
  }
  const result = await response.json();

  if (!ok)
    return Promise.reject(
      "There was an error getting the policy's enrollment status"
    );
  return Promise.resolve(result);
};

/*
curl --location --request POST 'https://cluster.ss-stage.icg360.net/home-services/benefits/rules' \
--header 'Content-Type: application/json' \
--data-raw '{
  "policyId": "LARA16346100",
  "ruleNames": ["bees-360-inspection-renewal-write-out-benefit-rule", "new-business-inspection--write-out-benefit-rule"]
}'
  */
export const getInspectionWriteOuts = async ({
  policyId,
  ruleNames = [
    INSPECTION_WRITEOUTS.NEW_BIZ_WRITE_OUT_MSG
    // "new-business-inspection--write-out-benefit-rule"
  ]
}) => {
  if (!policyId) return Promise.reject(policyIdRequiredError);
  const apiUrl = getApiUrl("homeservices");
  const fullUrl = `${apiUrl}/benefits/rules`;
  const response = await fetch(fullUrl, {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      policyId,
      ruleNames
    })
  });
  if (!response.ok) {
    return Promise.reject("There was an error getting inspection write-outs.");
  }
  const result = await response.json();
  return Promise.resolve(result);
};
